import { atom, useSetRecoilState, useRecoilValue } from 'recoil';

/**
 * A boolean state defining wheter the support panel is open
 */
const isSupportPanelOpen = atom({
  key: 'isSupportPanelOpen',
  default: false,
});

export const useIsSupportPanelOpen = () => useRecoilValue(isSupportPanelOpen);

export const useSetIsSupportPanelOpen = () =>
  useSetRecoilState(isSupportPanelOpen);
